/**
 * @fileoverview API service for Contacts CRM.
 */

import { BE_URLS } from "@/constants/config.js";
import axios from "@/api/axios/axios_core_deal.js";

const DEAL_HOST = BE_URLS.BACKEND_DEAL_SERVER_URL;

// ==========================================
// Contact CRUD
// ==========================================

export async function getContacts(params) {
  const response = await axios.get(`${DEAL_HOST}/contacts`, { params });
  return response.data;
}

export async function getContact(id) {
  const response = await axios.get(`${DEAL_HOST}/contacts/${id}`);
  return response.data;
}

export async function createContact(data) {
  const response = await axios.post(`${DEAL_HOST}/contacts`, data);
  return response.data;
}

export async function updateContact(id, data) {
  const response = await axios.put(`${DEAL_HOST}/contacts/${id}`, data);
  return response.data;
}

export async function deleteContact(id) {
  const response = await axios.delete(`${DEAL_HOST}/contacts/${id}`);
  return response.data;
}

// ==========================================
// Tags
// ==========================================

export async function getContactTags() {
  const response = await axios.get(`${DEAL_HOST}/contacts/tags`);
  return response.data;
}

export async function addContactTag(id, tag) {
  const response = await axios.post(`${DEAL_HOST}/contacts/${id}/tags/${encodeURIComponent(tag)}`);
  return response.data;
}

export async function removeContactTag(id, tag) {
  const response = await axios.delete(`${DEAL_HOST}/contacts/${id}/tags/${encodeURIComponent(tag)}`);
  return response.data;
}

// ==========================================
// Notes
// ==========================================

export async function addContactNote(id, text) {
  const response = await axios.post(`${DEAL_HOST}/contacts/${id}/notes`, { text });
  return response.data;
}

// ==========================================
// CSV Import
// ==========================================

export async function importPreview(file) {
  var formData = new FormData();
  formData.append('file', file);
  var response = await axios.post(DEAL_HOST + '/contacts/import/preview', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
}

export async function importContacts(file, mapping, mode, tags) {
  var formData = new FormData();
  formData.append('file', file);
  formData.append('mapping', JSON.stringify(mapping));
  formData.append('mode', mode || 'CREATE_OR_UPDATE');
  if (tags) formData.append('tags', tags);
  var response = await axios.post(DEAL_HOST + '/contacts/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
}

// ==========================================
// Bulk Actions
// ==========================================

export async function bulkAddTag(contactIds, tag) {
  var response = await axios.post(DEAL_HOST + '/contacts/bulk/tag', { contactIds: contactIds, tag: tag });
  return response.data;
}

export async function bulkRemoveTag(contactIds, tag) {
  var response = await axios.post(DEAL_HOST + '/contacts/bulk/untag', { contactIds: contactIds, tag: tag });
  return response.data;
}

export async function bulkDeleteContacts(contactIds) {
  var response = await axios.post(DEAL_HOST + '/contacts/bulk/delete', { contactIds: contactIds });
  return response.data;
}

// ==========================================
// Migration
// ==========================================

export async function migrateContacts() {
  var response = await axios.post(DEAL_HOST + '/contacts/migrate');
  return response.data;
}

// ==========================================
// Segments
// ==========================================

export async function getSegments() {
  var response = await axios.get(DEAL_HOST + '/contacts/segments');
  return response.data;
}

export async function createSegment(data) {
  var response = await axios.post(DEAL_HOST + '/contacts/segments', data);
  return response.data;
}

export async function updateSegment(id, data) {
  var response = await axios.put(DEAL_HOST + '/contacts/segments/' + id, data);
  return response.data;
}

export async function deleteSegment(id) {
  var response = await axios.delete(DEAL_HOST + '/contacts/segments/' + id);
  return response.data;
}

export async function previewSegment(id) {
  var response = await axios.get(DEAL_HOST + '/contacts/segments/' + id + '/preview');
  return response.data;
}

// ==========================================
// Timeline
// ==========================================

export async function getContactTimeline(id, params) {
  const response = await axios.get(`${DEAL_HOST}/contacts/${id}/activity`, { params });
  return response.data;
}
